const AU_ID = 'gmh7FbZAPfdhffQZ5ICrMa8XSHC1ZnlHU0msKEgl';
const US_ID = 'jDWhNVErql4Q7cITB8zHywr0NI5L2ecE7Ev8BXJi';
const UK_ID = 'y9ocJLhkmjbdGAQ7HlZcoOn9xdz92KuzaIOkPPnN';
const EU_ID = 'OGEz5d1d2Jl40c7nprHLeilaThFjQIOo4lFqJPJ4';
let storeId = AU_ID;

switch (window?.Shopify?.shop) {
    case 'vida-glow.myshopify.com':
        storeId = US_ID;
        break;
    case 'vidaglowuk.myshopify.com':
        storeId = UK_ID;
        break;
    case 'vidagloweu.myshopify.com':
        storeId = EU_ID;
        break;
}

document.addEventListener('DOMContentLoaded', () => {
    setTimeout(async () => {
        const reviewElements = document.querySelectorAll('.yotpo-custom-request');
        if (reviewElements.length > 0) {
            for (let i = 0; i < reviewElements.length; i++) {
                const reviewElement = reviewElements[i];
                const productId = reviewElement.getAttribute('data-yotpo-custom-product-id');
                if (productId && !reviewElement.classList.contains('populated')) {
                    const reviewData = await fetchReview(productId);
                    const productMatches = document.querySelectorAll(`[data-yotpo-custom-product-id="${productId}"]`);
                    productMatches.forEach((match) => {
                        insertReviewHtml(match, reviewData[0]);
                    });
                }
            }
        }
    }, 2500);
});

const fetchReview = async (productId) => {
    try {
        const response = await fetch(`https://api-cdn.yotpo.com/v1/widget/${storeId}/products/${productId}/reviews.json`);
        const data = await response.json();
        return [data?.response?.bottomline];
    } catch (error) {
        console.error('Error fetching Yotpo reviews:', error);
    }
}

const insertReviewHtml = (parent, reviewData) => {
    if (!parent || !reviewData) return;

    const total = reviewData.total_review || 0;
    const averageNum = reviewData.average_score;
    const averageScore = averageNum?.toFixed(1) || 0;
    const stars = ['a','b','c','d','e'];

    const reviewHtml = `
        <div class="yotpo-reviews-star-ratings-widget yotpo-star-ratings-widget-override-css yotpo-device-desktop yotpo-display-l" id="yotpo-reviews-star-ratings-widget" style="display: flex; justify-content: left; flex-direction: row; margin-bottom: 5px;">
        <div class="yotpo-widget-clear yotpo-bottom-line-scroll-panel" style="display: flex; align-items: flex-start; flex-flow: column wrap; gap: 4px;">
          <div class="yotpo-sr-bottom-line-summary" style="display: flex; flex-direction: column; align-items: flex-start; gap: 4px; margin-right: 0px; direction: ltr; cursor: initial;">
            <div style="display: flex;">
              <span role="img" aria-label="${averageScore} out 5 stars rating in total ${total} reviews" title="${averageScore} out 5 stars rating in total ${total} reviews" style="display: flex; flex-direction: row; align-items: center; margin-left: 0px; height: 28px;">
                ${stars.map((star, index) => {
                    const type = averageNum >= (index + 0.8) ? 'full' : averageNum >= (index + 0.3) ? 'half' : 'empty';
                    return `
                        <svg aria-hidden="true" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" class="star-container yotpo-sr-star-${type}" width="15" height="15" style="display: flex; flex-direction: row; margin-inline-end: 3.5px;">
                            <defs>
                                <linearGradient id="ysg-${star}">
                                <stop offset="${type !== 'half' ? '100%' : '51%'}" stop-color="rgba(44,44,44,1)"></stop>
                                <stop stop-opacity="1" offset="100%" stop-color="${type !== 'empty' ? '#000000' : '#FFFFFF'}"></stop>
                                </linearGradient>
                            </defs>
                            <path style="pointer-events: none;" d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="rgba(44,44,44,1)" fill="url('#ysg-${star}')"></path>
                        </svg>
                    `
                }).join('')}
              </span>
            </div>
            <div class="yotpo-sr-bottom-line-right-panel">
                <p class="yotpo-sr-bottom-line-text yotpo-sr-bottom-line-text--right-panel" style="white-space: nowrap; font-size: 16px; text-align: start; font-family: GalanoGrotesque; font-style: normal; font-weight: 400; color: rgb(44, 44, 44); padding-top: 2px; line-height: 28px; margin-bottom: 0;">
                    ${total} Reviews
                </p>
            </div>    
          </div>
        </div>
      </div>
    `;

    parent.innerHTML = reviewHtml;
    parent.classList.add('populated');
}